<template>
  <div>
    <LoadingSpinner :loading="loading" />
    <MatrixTextTable
      v-if="!loading"
      :title="title"
      :fields="fields"
      :items="items"
      :stickyHeader="false"
    />
  </div>
</template>

<script>
import MatrixTextTable from "@/components/global/MatrixTextTable";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  components: {
    MatrixTextTable,
    LoadingSpinner,
  },
  data() {
    return {
      loading: false,
      title: "",
      items: [],
    };
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    withProps: {
      type: Boolean,
      default: false,
    },
    resourceCode: {
      type: [String, Number],
      default: null,
    },
    examPackId: {
      type: [String, Number],
      default: null,
    },
    parvandehCode: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    fields() {
      return [
        {
          key: "caption",
          label: "محور ارزیابی",
          class: "text-center",
          thClass: "w-25",
          tdClass: "p-2 text-muted font-weight-bold text-left fs_12",
        },
        {
          key: "score",
          label: "وضعیت",
          class: "text-center",
          thClass: "",
          tdClass: "p-1 text-muted fs_12",
        },
        {
          key: "description",
          label: "توضیحات",
          class: "text-center",
          thClass: "w-75",
          tdClass: "p-2 text-muted text-left fs_12",
        },
      ];
    },
    renderResourceCode() {
      return this.withProps
        ? this.resourceCode
        : this.$route.params.resourceCode;
    },
    renderExamPackId() {
      return this.withProps ? this.examPackId : this.$route.params.examPackId;
    },
    renderParvandehCode() {
      return this.withProps
        ? this.parvandehCode
        : this.$route.params.parvandehCode;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    generateApiUrl,
    async fetchData() {
      try {
        this.loading = true;
        const url = generateApiUrl(
          ["azmoon", "calculate_karnameh"],
          [this.renderParvandehCode],
          {
            azmoon_person_code: this.renderResourceCode,
            exam_pack_id: this.renderExamPackId,
            display_type: "html",
          }
        );
        const response = await this.$httpService.get(url);
        const responseData = pathOr(null, ["data", "data"], response);
        const examPackShowName = pathOr(
          "",
          ["exam_pack_show_name"],
          responseData
        );
        const fullName = `${pathOr(
          "",
          ["person_info", "name"],
          responseData
        )} ${pathOr("", ["person_info", "family"], responseData)}`;
        const parvandehNumber = pathOr(
          "",
          ["person_info", "parvandeh_number"],
          responseData
        );
        this.title = this.showTitle
          ? `${examPackShowName} برای <span class='text-primary'>${fullName}</span> با شماره پرونده: <span class='text-primary'>${parvandehNumber}</span>`
          : "";
        const data = pathOr(
          "",
          ["data", "data", "components", "parent"],
          response
        );
        const items = pathOr([], ["items"], data);
        this.items = items.map((item) => {
          return {
            caption: pathOr(null, ["title"], item),
            score: pathOr(null, ["rank_title"], item),
            description: pathOr(null, ["text"], item),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
